// ABOUTME: Route for /skills/shared — shows skills shared by teammates.
import { SharedSkillsPage } from "@/components/skills/SharedSkillsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/skills/shared")({
  component: SharedSkillsPage,
});
